<template>
<div class="page">
    <div class="listHead">
        <panel
            ref="panel"
            :wapTitle="''"
            :appLink="'/2/8/0'"
            :spreadID="'0'"
            :noPosHeader="true"
            :extinfo="extinfo"
            :showNav="false"
            :isShowNav="false"
            @gotoApp="gotoApp"
            :isApp="false"
        ></panel>
        <div class="titleBox"><img @click="goBack()" src="@/assets/img/icon_left.png"> 拍行视频</div>

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad">

                <template v-for="(item,i) in collectList">
                    <div :key="'collectList'+i" class="collectCard" @click="jumpDetails(item)">
                        <div class="collectName"><img :src="item.organ_cover" alt=""> <span>{{item.organ_name}}</span></div>
                        <div class="coverBox">
                            <span class="icoVideo"></span>
                            <img :src="item.cover" alt="">
                        </div>

                        <div class="dateBox">{{item.title}}</div>
                    </div>

                </template>
                <EmptyPage v-if="page === 1 && !collectList.length && !loading" />

                <template #finished v-if="collectList.length">
                    <div class="noMore">
                        <span>我是有底线的</span>
                    </div>
                </template>
            </van-list>
        </van-pull-refresh>

    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
</div>
</template>

<script>
import {
    getWXConfig
} from "@/assets/js/weixinShare";
import panel from "@/views/preview/component/panel";
import DownLoadApp from '@/components/common/downloadApp'
import EmptyPage from '@/components/empty/emptyPage.vue'
import {
    videoList
} from "@/api/new";
export default {
    components: {
        DownLoadApp,
        panel,
        EmptyPage
    },
    data() {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            isApp: false,
            collectList: [],
            appLinkShow: true,
            extinfo:'',
            // 通链接数据
            appLink: '/2/8/0',
        }
    },
    methods: {
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        numFun(e) {
            let newArray = this.collectList.company_list.filter(item => {
                return item.show_rank == e;
            });
            if (newArray.length == 1) {
                return false;
            } else {
                return true;
            }

        },
        jumpDetails(e) {
                this.$router.push({
                    path: "/videoPlay?type=1&id=" + e.id
                });
           
        },
        goBack() {
            if (document.referrer) {
                window.location.href = document.referrer
            } else if (window.history.state) {
                this.$router.back()
            } else if (this.$route.query.fromlink) {
                window.location.href = decodeURIComponent(this.$route.query.fromlink)
            } else {
                this.$router.push({
                    path: "/"
                });
            }
        },
        onLoad() {
            videoList({
                page: this.page
            }).then(res => {
                if (res.code === 0) {
                    if (this.refreshing) {
                        this.list = []
                        this.refreshing = false
                    }
                    this.collectList.push(...res.data.list)

                    this.loading = false
                    this.page++

                    if (!res.data.morePage) {
                        this.finished = true
                    }
                }
            })
        },
        onRefresh() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.page = 1
            this.finished = false
            this.loading = true
            this.onLoad()
        },

    },
    mounted() {
        this.isApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
        this.extinfo=JSON.stringify({url: "videoList",param: ''})
        document.title = "拍行视频 - 雅昌拍卖图录"
        window.AFedWxShareData = {
            title: "拍行视频 - 雅昌拍卖图录APP",
            imgUrl: 'https://components.artron.net/auction/h5img/logo/share_logo.png',
            desc: "雅昌拍卖图录全能助手，拍卖无忧",
            link: window.location.href
        }
        getWXConfig(window.AFedWxShareData)

    }
}
</script>

<style lang="scss">
body {
    background: #F5F5F5 !important;
}
</style>
<style lang="scss" scoped>
.page {
    background-color: #F5F5F5;

    .listHead {

        width: 100%;
        padding-top: 4.4rem;

        .collectCard {
            width: 100%;
            margin: 1rem 0;
            background: #FFFFFF;
            box-shadow: 0px 14px 26px -10px rgba(0, 0, 0, 0.1);
            border-radius: 1rem;
            padding-bottom: 0.5rem;
            box-sizing: border-box;

            .dateBox {
                width: 100%;
                padding: 0.5rem 1rem;
                font-size: 0.8rem;
                font-weight: 400;
                margin-top: 5px;
                box-sizing: border-box;

            }

            .coverBox {
                width: 100%;
                height: 9rem;
                padding: 0 0.8rem;
                box-sizing: border-box;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    position: relative;
                    z-index: 3;
                    border-radius: 1rem;
                }

                .icoVideo {
                    width: 2rem;
                    height: 2rem;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    z-index: 4;
                    transform: translate(-50%, -50%);
                    background: url("../../assets/img/icon_btn_play.png") no-repeat;
                    background-size: cover;
                }

                .more {
                    position: absolute;
                    width: 80%;
                    height: 80px;
                    left: 10%;
                    bottom: -14px;
                    z-index: 2;
                }
            }

            .collectName {
                width: 100%;
                padding: 0.7rem 1rem;
                box-sizing: border-box;

                img {
                    width: 2rem;
                    height: 2rem;
                    margin-right: 0.2rem;
                    border-radius: 2rem;
                    border: 1px solid rgba(0, 0, 0, 0.06);
                    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.06);
                    vertical-align: middle;

                }

                span {
                    font-size: 0.75rem;
                    font-weight: 600;
                }

            }
        }

        .titleBox {
            width: 100%;
            height: 2rem;
            z-index: 5;
            background: #F5F5F5;
            font-size: 0.7rem;
            line-height: 2rem;
            font-weight: 600;
            color: #000000;
            text-align: center;
            position: fixed;
            top: 2.4rem;
            left: 0;

            img {
                position: absolute;
                left: 0;
                top: 0;
                width: 48px;
                height: 40px;
            }
        }

    }

}
</style>
